import {Component, OnInit, Output, EventEmitter, OnDestroy, Input} from '@angular/core';
import {GtNameValueService} from '../../../../services/gt-name-value.service';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {Subject} from 'rxjs';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {GtServiceNumbersUtil} from '../../../../shared/utils/gt-service-numbers.util';
import {AbstractContactModel, ContactType} from '../../../../models/abstract-contact.model';

@Component({
  selector: 'gt-myservice-settings',
  templateUrl: './myservice-settings.component.html',
  styleUrls: ['./myservice-settings.component.scss']
})
export class MyserviceSettingsComponent implements OnInit, OnDestroy {
  @Input() login: string;
  @Input() orgname: string;

  @Output()
  public backObservable = new EventEmitter<void>();

  public twoHigh0 = false;
  public twoHigh1 = false;
  public twoHigh2 = false;

  public serviceNumbers: AbstractContactModel[];
  public colleagueNumbers: AbstractContactModel[];
  public colleagueNumber: string;
  public mainNumber: string;

  private destroyed = new Subject<void>();

  constructor(
    private authenticationService: GtAuthenticationService,
    private nameValueService: GtNameValueService,
    private directoryService: GtDirectoryService
  ) {}

  ngOnInit() {
    this.login = this.login ? this.login : this.authenticationService.login;
    this.orgname = this.orgname ? this.orgname : this.authenticationService.oname;

    this.directoryService.getServiceNumberModels(this.orgname, false).subscribe(
      r => {
        this.serviceNumbers = r.filter(snd => GtServiceNumbersUtil.isMainNumber(snd));
      },
      e => console.log(e)
    );

    this.directoryService.getContacts(this.orgname, false).subscribe(
      r => {
        this.colleagueNumbers = r.filter(e => (e.type = ContactType.EndUser));
      },
      e => console.log(e)
    );

    this.nameValueService.getEndUserNameValue('AbsenceSecretaryNumber', this.orgname, this.login).subscribe(r => {
      this.colleagueNumber = r;
    });

    this.nameValueService.getEndUserNameValue('AbsenceSwitchboardNumber', this.orgname, this.login).subscribe(r => {
      this.mainNumber = r;
    });

    this.nameValueService.getEndUserNameValue('PAProfile', this.orgname, this.login).subscribe(r => {
      const binRep = Number(r).toString(2);
      this.twoHigh0 = Boolean(Number(binRep.charAt(2)));
      this.twoHigh1 = Boolean(Number(binRep.charAt(1)));
      this.twoHigh2 = Boolean(Number(binRep.charAt(0)));
    });
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }

  updatePAProfileInBackend() {
    this.nameValueService.setEndUserNameValue('PAProfile', this.calcPAProfileNumber(), this.orgname, this.login).subscribe();
  }

  changeColleagueNumber(event) {
    this.nameValueService.setEndUserNameValue('AbsenceSecretaryNumber', event.value, this.orgname, this.login).subscribe();
  }

  changeMainNumber(event) {
    this.nameValueService.setEndUserNameValue('AbsenceSwitchboardNumber', event.value, this.orgname, this.login).subscribe();
  }

  calcPAProfileNumber(): string {
    return parseInt(Number(this.twoHigh2) + '' + Number(this.twoHigh1) + '' + Number(this.twoHigh0), 2) + '';
  }

  onBack() {
    this.backObservable.emit();
  }
}
